import React, { Fragment } from "react";
import { useQuery } from "@apollo/client";

import {
  EuiTitle,
  EuiSpacer,
  EuiProgress,
  EuiText,
  EuiFormRow,
  EuiFlexGroup,
  EuiFlexItem,
  EuiFieldText,
  EuiCallOut,
} from "@elastic/eui";
import moment from "moment";

import AssistantIngredients from "../components/AssistantIngredients";
import ASSISTANT_MESSAGE from "../querys/AssistantMessage";

function FoodLogAssistant({ id }) {
  const { loading, error, data } = useQuery(ASSISTANT_MESSAGE, {
    variables: { id: id },
  });
  if (loading)
    return (
      <div>
        <EuiProgress size="xs" color="accent" />
      </div>
    );

  if (error) return `Error! ${error}`;

  var utcDate = moment.utc(data.assistantMessage.createdAt).toDate();
  var timestamp = moment(utcDate).local().fromNow();

  return (
    <Fragment>
      <EuiTitle size="l">
        <h1>Food log assistant 🤖 </h1>
      </EuiTitle>
      <small>Message created at: {timestamp}</small>

      <EuiSpacer size="s" />
      <EuiCallOut
        size="s"
        title="Read-only: logging food on a user's behalf from greedo was removed (Oct 2026)."
        iconType="iInCircle"
      />

      {data.assistantMessage.isLogged && (
        <EuiCallOut
          title="This food is already logged!"
          color="success"
          iconType="check"
        ></EuiCallOut>
      )}

      <EuiSpacer />

      <EuiText size="s">
        <p>User Input:</p>
        <blockquote>{data?.assistantMessage.message}</blockquote>
      </EuiText>

      <EuiSpacer />

      <EuiFlexGroup style={{ maxWidth: 800 }}>
        <EuiFlexItem>
          <EuiFormRow label="Food name" helpText="Auto generated name by GPT">
            <EuiFieldText
              value={data?.assistantMessage.metadata?.title}
              disabled={true}
            />
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label="Meal time">
            <EuiFieldText value={data?.assistantMessage.mealTime} disabled={true} />
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiSpacer />

      <AssistantIngredients
        list={data.assistantMessage.gptingredientSet.edges}
      />

    </Fragment>
  );
}

export default FoodLogAssistant;
